import { render, staticRenderFns } from "./QuickSearch.vue?vue&type=template&id=5670c2ad"
import script from "./QuickSearch.vue?vue&type=script&lang=js"
export * from "./QuickSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports